import React, {useCallback, useEffect, useState, useMemo} from 'react';
import Wrapper from "../components/Wrapper";
import Api from "../Api";
import {Helmet} from "react-helmet";
import {amo, crm, input, sip, bitrix, historyHeader, global} from "../translate";
import {
    Paper,
    Box,
    Typography,
    TextField,
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableFooter,
    FormControlLabel,
    Checkbox,
    Avatar,
    InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CloseIcon from "@mui/icons-material/Close";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import Cookies from "js-cookie";
import Loader from "../components/Loader";
import {toast} from "react-toastify";
import Select from "react-select";
import {greenTheme} from "../helpers/style";

const {REACT_APP_SERVER} = process.env;
const primary = REACT_APP_SERVER === 'ATS' ? '#0973b9' : greenTheme.primary;
let newArr = []
const CARD_TYPE_VALUES = ['lead', 'contact', 'deal'];
const DISPLAY_MODE_PHONE_VALUES = ['plus', 'local', 'under'];
const parseDisplayModePhone = (raw) => (DISPLAY_MODE_PHONE_VALUES.includes(raw) ? raw : '');
const normalizeOrder = (order) => (String(order || '').toLowerCase() === 'desc' ? 'DESC' : 'ASC');
const emptyAssigned = () => ({
    lead: { status: [], order: 'ASC' },
    deal: { stage: [], order: 'ASC' },
    contact: { order: 'ASC' },
});
const parseLeadAssigned = (raw) => {
    if (!raw || typeof raw !== 'object') return { status: [], order: 'ASC' };
    return {
        status: Array.isArray(raw.status) ? raw.status : [],
        order: normalizeOrder(raw.order),
    };
};
const parseDealAssigned = (raw) => {
    if (!raw || typeof raw !== 'object') return { stage: [], order: 'ASC' };
    const stage = Array.isArray(raw.stage)
        ? raw.stage
        : (Array.isArray(raw.status) ? raw.status : []);
    return {
        stage,
        order: normalizeOrder(raw.order),
    };
};
const parseContactAssigned = (raw) => {
    if (!raw || typeof raw !== 'object') return { order: 'ASC' };
    return { order: normalizeOrder(raw.order) };
};
const parseCardTypes = (raw) => {
    const list = Array.isArray(raw) ? raw : (raw ? [raw] : []);
    const filtered = list.filter((v) => CARD_TYPE_VALUES.includes(v));
    return filtered.length ? filtered : ['lead'];
};
const buildAssignedPayload = (selectedTypes, assigned) => {
    const out = {};
    for (const type of selectedTypes) {
        if (type === 'contact') {
            out.contact = { order: normalizeOrder(assigned?.contact?.order) };
            continue;
        }
        if (type === 'deal') {
            const entity = assigned?.deal || { stage: [], order: 'ASC' };
            out.deal = {
                stage: Array.isArray(entity.stage) ? entity.stage : [],
                order: normalizeOrder(entity.order),
            };
            continue;
        }
        const entity = assigned?.lead || { status: [], order: 'ASC' };
        out.lead = {
            status: Array.isArray(entity.status) ? entity.status : [],
            order: normalizeOrder(entity.order),
        };
    }
    return out;
};
const defaultCallConfig = () => ({
    default: 0,
    card_type: ['lead'],
    assigned: emptyAssigned(),
    call_rate: 0,
    call_card_report: 1,
    responsible: 0,
    show_card: '',
    display_mode_phone: '',
});
const customStyles = {
    menu: (provided) => ({...provided, position: 'absolute', zIndex: 9999, maxHeight: 300}),
    menuPortal: (base) => ({...base, zIndex: 9999}),
    control: (base, state) => ({
        ...base,
        borderRadius: 10,
        minHeight: 40,
        borderColor: state.isFocused ? primary : 'rgba(0,0,0,0.23)',
        boxShadow: state.isFocused ? `0 0 0 2px ${primary}40` : base.boxShadow,
        '&:hover': { borderColor: primary },
    }),
};
function Bitrix24(props) {
    const lang = +localStorage.getItem('atsLang') || 1;
    const [res, setRes] = useState([]);
    const [sipNum, setSip] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [saving, setSaving] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const userData = useSelector((state) => state.users.crmData)
    const navigate = useNavigate()
    const [form, setForm] = useState({
        adminId: 0,
        key: '',
        startcall: '',
        domain: userData?.bitrix?.domain,
        lead: {},
    });
    const [callConfig, setCallConfig] = useState(defaultCallConfig);
    const [leadTypes, setLeadTypes] = useState([]);
    const [dealTypes, setDealTypes] = useState([]);
    useEffect(() => {
        (async () => {
            try {
                setLoading(true)
                const {data} = await Api.bitrix_get()
                const admin = await Api.bitrix_admin()

                if (!admin?.data?.admin?.ADMIN) {
                    alert(bitrix.login_admin[lang])
                    return
                }
                if (data.data.result) {
                    let arr = data.data.result.map(s => ({...s, sip: s.sip || ''}))
                    newArr = arr
                    setRes(arr)
                }
                let webhook = newArr.find(w => w.ID === admin?.data?.admin?.ID)
                setForm(prevState => ({
                    ...prevState, key: webhook?.key,  adminId: webhook?.ID
                }))
                setLoading(false)
            } catch (e) {
                console.log(e)
                if(e?.response?.data?.message === 'Application not found'){
                    navigate('/crm_integration#application_not_found')
                }else{
                    console.log(e?.response?.data?.message)

                }
            }
        })()
    }, [])
    useEffect(() => {
        (async () => {
            try {
                const {data} = await Api.getAllowed()
                setSip(data.inputNumber?.sip)
            } catch (e) {
            }
        })()
    }, []);
    useEffect(() => {
        (async () => {
            try {
                const [leadRes, dealRes] = await Promise.allSettled([
                    Api.bitrix_lead_types(),
                    Api.bitrix_deal_types(),
                ]);
                if (leadRes.status === 'fulfilled' && leadRes.value?.data?.leadTypes?.length) {
                    setLeadTypes(leadRes.value.data.leadTypes);
                }
                if (dealRes.status === 'fulfilled' && dealRes.value?.data?.dealTypes?.length) {
                    setDealTypes(dealRes.value.data.dealTypes);
                }
            } catch (e) {
                // ignore - entity types optional
            }
        })()
    }, []);
    const handleSipConnect = useCallback((item, index) => {
        newArr = newArr.map((a, i) => (i === index ? {...a, sip: item} : a));
        setRes([...newArr]);
    }, [])

    const handleSelectOnly = useCallback((item) => {
        setRes([...newArr]);
        setSelectedIds([item.ID]);
        setForm(prevState => ({
            ...prevState,
            startcall: item?.startcall || ''
        }));
    }, []);

    const handleToggleSelect = useCallback((item, checked) => {
        setSelectedIds((prev) => {
            if (checked) {
                return prev.includes(item.ID) ? prev : [...prev, item.ID];
            }
            return prev.filter((id) => id !== item.ID);
        });
        if (checked && item?.startcall) {
            setForm((prevState) => ({
                ...prevState,
                startcall: item.startcall || prevState.startcall || '',
            }));
        }
    }, []);

    const handleCorpChange = useCallback((index, corp) => {
        newArr = newArr.map((a, i) => (i === index ? {...a, corporation: +corp} : a));
        setRes([...newArr]);
    }, [])

    const handleBulkCorpChange = useCallback((corp, ids) => {
        newArr = newArr.map((a) => (ids.includes(a.ID) ? {...a, corporation: +corp} : a));
        setRes([...newArr]);
    }, [])

    const buildCrmPayload = useCallback(() => {
        const { incoming, outgoing, missed, call_rate, lead, call_card_report, assigned, default: _default, show_card, card_type, display_mode_phone, ...crmPayload } = callConfig;
        const selectedTypes = parseCardTypes(card_type);
        const phoneMode = parseDisplayModePhone(display_mode_phone);
        return {
            ...crmPayload,
            card_type: selectedTypes,
            call_card_report: 1,
            call_rate,
            ...(+(callConfig.responsible) === 1
                ? { assigned: buildAssignedPayload(selectedTypes, assigned) }
                : {}),
            ...(show_card ? { show_card } : {}),
            ...(phoneMode ? { display_mode_phone: phoneMode } : {}),
        };
    }, [callConfig]);

    const saveOneWorker = useCallback(async (item, index) => {
        if (!item?.sip) {
            if (item?.crmId) {
                await Api.bitrix_delete_crm(item.crmId);
                newArr = newArr.map((a, i) => (i === index ? {...a, crmId: 0} : a));
            }
            return false;
        }

        const payload = buildCrmPayload();
        if (+item.crmId) {
            await Api.bitrix_edit({
                id: item.crmId,
                ...((form.key != null && form.key !== '') ? { key: form.key } : {}),
                startcall: form.startcall,
                adminID: form.adminId,
                sip: item?.sip,
                userID: item.ID,
                corporation: item?.corporation || 0
            });
            await Api.crmConfigs(payload, item.sip, item.crmId);
            return true;
        }

        const {data} = await Api.bitrix_create({
            ...((form.key != null && form.key !== '') ? { key: form.key } : {}),
            startcall: form.startcall,
            adminID: form.adminId,
            sip: item?.sip,
            userID: item.ID,
            corporation: item?.corporation
        });
        newArr = newArr.map((a, i) => (i === index ? {...a, crmId: data.crm.id} : a));
        if (data.crm?.id && item.sip) {
            await Api.crmConfigs(payload, item.sip, data.crm.id);
        }
        return true;
    }, [form, buildCrmPayload]);

    const handleSaveSelected = useCallback(async (users) => {
        if (!users?.length) return;
        const withSip = users.filter((u) => u?.sip);
        const withoutSip = users.filter((u) => !u?.sip);
        if (!withSip.length) {
            toast.error(bitrix.workers_need_sip[lang]);
            return;
        }
        try {
            setSaving(true);
            for (const item of withSip) {
                const index = newArr.findIndex((r) => r.ID === item.ID);
                if (index < 0) continue;
                await saveOneWorker(item, index);
            }
            setRes([...newArr]);
            toast.success(global.success[lang]);
            if (withoutSip.length) {
                toast.warn(bitrix.workers_need_sip[lang]);
            }
        } catch (e) {
        } finally {
            setSaving(false);
        }
    }, [lang, saveOneWorker])

    const handleWebhook = useCallback((name, val) => {
        setForm((prev) => ({...prev, [name]: val}));
    }, []);

    const handleCallConfigSelect = useCallback((name, ev) => {
        setCallConfig(prev => ({...prev, [name]: ev?.value ?? ''}));
    }, []);

    // const callConfigOptions = useMemo(() => {
    //     return {
    //         incoming: [
    //             { value: 'nothing', label: historyHeader.nothing[lang] },
    //             { value: 'contact', label: historyHeader.contact[lang] },
    //             { value: 'contact_deal', label: historyHeader.contact_lead[lang] },
    //             { value: 'none', label: historyHeader.unsorted[lang] },
    //         ],
    //         outgoing: [
    //             { value: 'nothing', label: historyHeader.nothing[lang] },
    //             { value: 'contact', label: historyHeader.contact[lang] },
    //             { value: 'contact_deal', label: historyHeader.contact_lead[lang] },
    //         ],
    //         missed: [
    //             { value: 'nothing', label: historyHeader.nothing[lang] },
    //             { value: 'contact', label: historyHeader.contact[lang] },
    //             { value: 'contact_deal', label: historyHeader.contact_lead[lang] },
    //             { value: 'none', label: historyHeader.unsorted[lang] },
    //         ],
    //     };
    // }, [lang]);

    const selectedUsers = useMemo(
        () => selectedIds.map((id) => res.find((r) => r.ID === id)).filter(Boolean),
        [selectedIds, res]
    );
    const isMulti = selectedUsers.length > 1;
    const selectedUserData = selectedUsers[0] || null;
    const configSourceUser = useMemo(
        () => selectedUsers.find((u) => u?.crmId && u?.sip) || selectedUserData,
        [selectedUsers, selectedUserData]
    );
    const allSelectedHaveCorp = selectedUsers.length > 0 && selectedUsers.every((u) => !!u?.corporation);
    const someSelectedHaveCorp = selectedUsers.some((u) => !!u?.corporation);

    useEffect(() => {
        if (configSourceUser?.crmId && configSourceUser?.sip) {
            (async () => {
                try {
                    const {data} = await Api.getCrmConfigs(configSourceUser.crmId);
                    if (data.config?.access_actions) {
                        const jsonString = String.fromCharCode(...data.config.access_actions.data);
                        const jsonData = JSON.parse(jsonString);
                        const { incoming, outgoing, missed, rated_calls_to_manager, lead: _lead, ...rest } = jsonData;
                        setCallConfig({
                            ...rest,
                            default: +(jsonData.call_rate) === 1 ? 1 : 0,
                            card_type: parseCardTypes(jsonData.card_type),
                            assigned: {
                                lead: parseLeadAssigned(jsonData.assigned?.lead),
                                deal: parseDealAssigned(jsonData.assigned?.deal),
                                contact: parseContactAssigned(jsonData.assigned?.contact),
                            },
                            call_rate: +(jsonData.call_rate) === 1 ? 1 : 0,
                            call_card_report: 1,
                            responsible: +(jsonData.responsible) === 1 ? 1 : 0,
                            show_card: (jsonData.show_card === 'only_answer' || jsonData.show_card === 'all') ? jsonData.show_card : '',
                            display_mode_phone: parseDisplayModePhone(jsonData.display_mode_phone),
                        });
                    } else {
                        setCallConfig(defaultCallConfig());
                    }
                } catch (e) {
                    setCallConfig(defaultCallConfig());
                }
            })();
        } else {
            setCallConfig(defaultCallConfig());
        }
    }, [configSourceUser?.crmId, configSourceUser?.sip]);

    const filteredRes = useMemo(() => {
        if (!searchQuery.trim()) return res;
        const q = searchQuery.toLowerCase();
        return res.filter((s) =>
            `${s.NAME || ''} ${s.LAST_NAME || ''} ${s.EMAIL || ''}`.toLowerCase().includes(q)
        );
    }, [res, searchQuery]);

    const cardPaperSx = {
        p: 2.5,
        borderRadius: 3,
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        border: '1px solid rgba(0,0,0,0.06)',
    };

    return (
        <>
            <Helmet><title>{sip.crm[lang]}</title></Helmet>
            <Wrapper>
                <div className="tableParent">
                    {(form.key || form.startcall) && (
                    <Paper sx={{...cardPaperSx, mb: 3, p: 3}}>
                        <Typography variant="h6" fontWeight={700} sx={{mb: 2, color: 'text.primary'}}>
                            {bitrix.webhook[lang]}
                        </Typography>
                        <Box sx={{display: 'flex', flexDirection: 'column', gap: 2.5, maxWidth: 480}}>
                            <Box>
                                <Typography variant="subtitle2" fontWeight={600} sx={{mb: 0.75, color: 'text.secondary'}}>
                                    {bitrix.inbound_webhook[lang]}
                                </Typography>
                                <TextField
                                    fullWidth
                                    size="small"
                                    value={Cookies.get("key") ? (form.key ? '••••••••••••••••••••' : '') : form.key}
                                    onChange={(ev) => handleWebhook('key', ev.target.value)}
                                    placeholder={bitrix.enter_inbound_webhook[lang]}
                                    disabled={!!Cookies.get("key")}
                                    sx={{'& .MuiOutlinedInput-root': {borderRadius: 2}}}
                                />
                            </Box>
                            <Box>
                                <Typography variant="subtitle2" fontWeight={600} sx={{mb: 0.75, color: 'text.secondary'}}>
                                    {bitrix.outbound_webhook[lang]}
                                </Typography>
                                <TextField
                                    fullWidth
                                    size="small"
                                    value={Cookies.get("key") ? (form.startcall ? '••••••••••••••••••••' : '') : form.startcall}
                                    onChange={(ev) => handleWebhook('startcall', ev.target.value)}
                                    placeholder={bitrix.enter_outbound_webhook[lang]}
                                    disabled={!!Cookies.get("key")}
                                    sx={{'& .MuiOutlinedInput-root': {borderRadius: 2}}}
                                />
                            </Box>
                        </Box>
                    </Paper>
                    )}
                </div>

                {loading ? (
                    <div className="loaderContainer"><Loader/></div>
                ) : (
                    <div className="tableParent" id="tableParent" style={{display: 'flex', gap: 24, overflow: 'hidden', minWidth: 0}}>
                        {/* User list - wider than config when both shown */}
                        <Paper sx={{...cardPaperSx, flex: selectedUsers.length ? 1.5 : 1, minWidth: 0, minHeight: 0}}>
                            <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, gap: 1}}>
                                <Typography variant="subtitle1" fontWeight={700} color="text.primary">
                                    {bitrix.user_config[lang]}
                                </Typography>
                                {selectedIds.length > 0 && (
                                    <Typography variant="caption" color="text.secondary">
                                        {selectedIds.length} {bitrix.selected_count[lang]}
                                    </Typography>
                                )}
                            </Box>
                            <TextField
                                fullWidth
                                size="small"
                                placeholder={bitrix.search_users[lang]}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon sx={{color: 'text.secondary'}}/>
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{mb: 2, '& .MuiOutlinedInput-root': {borderRadius: 2}}}
                            />
                            <TableContainer sx={{maxHeight: 420}}>
                                <Table size="small" stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{fontWeight: 700, fontSize: '0.75rem'}}>{bitrix.bitrix_user[lang]}</TableCell>
                                            <TableCell sx={{fontWeight: 700, fontSize: '0.75rem'}}>{bitrix.mapped_to[lang]}</TableCell>
                                            <TableCell sx={{fontWeight: 700, fontSize: '0.75rem', width: 80}}>{historyHeader.status[lang]}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredRes.map((s) => {
                                            const isSelected = selectedIds.includes(s.ID);
                                            return (
                                                <TableRow
                                                    key={s.ID}
                                                    hover
                                                    selected={isSelected}
                                                    onClick={() => handleSelectOnly(s)}
                                                    sx={{cursor: 'pointer', bgcolor: isSelected ? `${primary}12` : undefined}}
                                                >
                                                    <TableCell>
                                                        <Box sx={{display: 'flex', alignItems: 'center', gap: 1.5}}>
                                                            <Avatar
                                                                onClick={(ev) => {
                                                                    ev.stopPropagation();
                                                                    handleToggleSelect(s, !isSelected);
                                                                }}
                                                                sx={{
                                                                    width: 36,
                                                                    height: 36,
                                                                    bgcolor: isSelected ? primary : 'grey.300',
                                                                    fontSize: '0.875rem',
                                                                    cursor: 'pointer',
                                                                    boxShadow: isSelected ? `0 0 0 2px ${primary}` : 'none',
                                                                    color: isSelected ? '#fff' : 'text.secondary',
                                                                }}
                                                            >
                                                                {(s.NAME?.[0] || '') + (s.LAST_NAME?.[0] || '')}
                                                            </Avatar>
                                                            <Box>
                                                                <Typography variant="body2" fontWeight={600}>{s.NAME} {s.LAST_NAME}</Typography>
                                                                <Typography variant="caption" color="text.secondary">{s.EMAIL}</Typography>
                                                            </Box>
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography variant="body2" color="text.secondary">
                                                            {s.sip ? `${s.sip} - ${sipNum.find((k) => +k.number === s.sip)?.context || ''}` : bitrix.not_assigned[lang]}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        {s?.ACTIVE ? (
                                                            <CheckCircleIcon sx={{color: primary, fontSize: 20}}/>
                                                        ) : (
                                                            <RadioButtonUncheckedIcon sx={{color: 'grey.400', fontSize: 20}}/>
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            {filteredRes.length === 0 && (
                                <Typography variant="body2" color="text.secondary" sx={{py: 3, textAlign: 'center'}}>
                                    {bitrix.no_users_found[lang]}
                                </Typography>
                            )}
                        </Paper>

                        {/* Right panel: Config - when one or more workers selected */}
                        {selectedUsers.length > 0 && (
                        <Paper sx={{...cardPaperSx, flex: 1, minWidth: 0, minHeight: 0, position: 'relative'}}>
                            {selectedUserData && (
                                <>
                                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2.5}}>
                                        <Typography variant="subtitle1" fontWeight={700} color="text.primary">
                                            {isMulti
                                                ? `${bitrix.config_for_selected[lang]} (${selectedUsers.length})`
                                                : `${bitrix.config_for[lang]} ${selectedUserData.NAME} ${selectedUserData.LAST_NAME}`}
                                        </Typography>
                                        <IconButton size="small" onClick={() => setSelectedIds([])} sx={{ml: 1}} aria-label="Close">
                                            <CloseIcon fontSize="small"/>
                                        </IconButton>
                                    </Box>
                                    <Box sx={{display: 'flex', flexDirection: 'column', gap: 2.5}}>
                                        {!isMulti && (
                                        <Box>
                                            <Typography variant="subtitle2" fontWeight={600} sx={{mb: 1, color: 'text.secondary'}}>
                                                {bitrix.user_mapping[lang]}
                                            </Typography>
                                            <Typography variant="body2" sx={{mb: 1}}>{bitrix.bitrix_user[lang]}: {selectedUserData.NAME} {selectedUserData.LAST_NAME}</Typography>
                                            <Box sx={{minWidth: 200}}>
                                                <Select
                                                    styles={customStyles}
                                                    menuPlacement="auto"
                                                    menuPortalTarget={document.body}
                                                    onChange={(ev) => handleSipConnect(ev.value, res.findIndex((r) => r.ID === selectedUserData.ID))}
                                                    value={selectedUserData.sip
                                                        ? {label: `${selectedUserData.sip} - ${sipNum.find((k) => +k.number === selectedUserData.sip)?.context || ''}`, value: selectedUserData.sip}
                                                        : {label: input.select[lang], value: ''}}
                                                    options={[{value: '', label: input.select[lang]}, ...sipNum.map((k) => ({value: +k.number, label: `${k.number} - ${k.context || ''}`}))]}
                                                    isSearchable
                                                />
                                            </Box>
                                        </Box>
                                        )}
                                        {isMulti && (
                                        <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1}}>
                                            {selectedUsers.map((u) => (
                                                <Typography
                                                    key={u.ID}
                                                    variant="caption"
                                                    sx={{
                                                        px: 1,
                                                        py: 0.5,
                                                        borderRadius: 1,
                                                        bgcolor: `${primary}14`,
                                                        color: 'text.secondary',
                                                    }}
                                                >
                                                    {u.NAME} {u.LAST_NAME}{u.sip ? ` · ${u.sip}` : ''}
                                                </Typography>
                                            ))}
                                        </Box>
                                        )}
                                        <Box>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={allSelectedHaveCorp}
                                                        indeterminate={!allSelectedHaveCorp && someSelectedHaveCorp}
                                                        onChange={(ev) => {
                                                            if (isMulti) {
                                                                handleBulkCorpChange(+ev.target.checked, selectedIds);
                                                            } else {
                                                                handleCorpChange(res.findIndex((r) => r.ID === selectedUserData.ID), +ev.target.checked);
                                                            }
                                                        }}
                                                        sx={{color: primary, '&.Mui-checked': {color: primary}, '&.MuiCheckbox-indeterminate': {color: primary}}}
                                                    />
                                                }
                                                label={<Typography variant="body2">{bitrix.boxed_version[lang]}</Typography>}
                                            />
                                        </Box>
                                        <Box>
                                            <Typography variant="subtitle2" fontWeight={600} sx={{mb: 1, color: 'text.secondary'}}>
                                                {bitrix.show_card_label[lang]}
                                            </Typography>
                                            <Box sx={{minWidth: 200}}>
                                                <Select
                                                    styles={customStyles}
                                                    menuPlacement="auto"
                                                    menuPortalTarget={document.body}
                                                    value={(() => {
                                                        const v = callConfig.show_card ?? '';
                                                        const opts = [
                                                            {value: '', label: input.select[lang]},
                                                            {value: 'all', label: bitrix.show_card_all[lang]},
                                                            {value: 'only_answer', label: bitrix.show_card_only_answer[lang]},
                                                        ];
                                                        return opts.find(o => o.value === v) || opts[0];
                                                    })()}
                                                    onChange={(ev) => setCallConfig(prev => ({...prev, show_card: ev?.value ?? ''}))}
                                                    options={[
                                                        {value: '', label: input.select[lang]},
                                                        {value: 'all', label: bitrix.show_card_all[lang]},
                                                        {value: 'only_answer', label: bitrix.show_card_only_answer[lang]},
                                                    ]}
                                                    isSearchable={false}
                                                />
                                            </Box>
                                        </Box>
                                        <Box>
                                            <Typography variant="subtitle2" fontWeight={600} sx={{mb: 1, color: 'text.secondary'}}>
                                                {bitrix.display_mode_phone_label[lang]}
                                            </Typography>
                                            <Box sx={{minWidth: 200}}>
                                                <Select
                                                    styles={customStyles}
                                                    menuPlacement="auto"
                                                    menuPortalTarget={document.body}
                                                    value={(() => {
                                                        const v = parseDisplayModePhone(callConfig.display_mode_phone);
                                                        const opts = [
                                                            {value: '', label: input.select[lang]},
                                                            {value: 'plus', label: bitrix.display_mode_phone_plus[lang]},
                                                            {value: 'local', label: bitrix.display_mode_phone_local[lang]},
                                                            {value: 'under', label: bitrix.display_mode_phone_under[lang]},
                                                        ];
                                                        return opts.find(o => o.value === v) || opts[0];
                                                    })()}
                                                    onChange={(ev) => setCallConfig(prev => ({...prev, display_mode_phone: ev?.value ?? ''}))}
                                                    options={[
                                                        {value: '', label: input.select[lang]},
                                                        {value: 'plus', label: bitrix.display_mode_phone_plus[lang]},
                                                        {value: 'local', label: bitrix.display_mode_phone_local[lang]},
                                                        {value: 'under', label: bitrix.display_mode_phone_under[lang]},
                                                    ]}
                                                    isSearchable={false}
                                                />
                                            </Box>
                                        </Box>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    size="small"
                                                    checked={+(callConfig.responsible) === 1}
                                                    onChange={(ev) => setCallConfig(prev => ({
                                                        ...prev,
                                                        responsible: ev.target.checked ? 1 : 0,
                                                    }))}
                                                    sx={{color: primary, '&.Mui-checked': {color: primary}}}
                                                />
                                            }
                                            label={<Typography variant="body2">{bitrix.responsible_manager[lang]}</Typography>}
                                            sx={{mt: 1}}
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    size="small"
                                                    checked={+(callConfig.call_rate) === 1}
                                                    onChange={(ev) => setCallConfig(prev => ({...prev, call_rate: ev.target.checked ? 1 : 0}))}
                                                    sx={{color: primary, '&.Mui-checked': {color: primary}}}
                                                />
                                            }
                                            label={<Typography variant="body2">{bitrix.rated_calls_to_manager[lang]}</Typography>}
                                            sx={{mt: 1}}
                                        />
                                        {+(callConfig.responsible) === 1 && (
                                        <Box sx={{mt: 2, display: 'flex', flexDirection: 'column', gap: 2}}>
                                            <Box>
                                                <Typography variant="subtitle2" fontWeight={600} sx={{mb: 1, color: 'text.secondary'}}>
                                                    {amo.paragraph_p3[lang]}
                                                </Typography>
                                                <Box sx={{minWidth: 200}}>
                                                    <Select
                                                        isMulti
                                                        styles={customStyles}
                                                        menuPlacement="auto"
                                                        menuPortalTarget={document.body}
                                                        value={(() => {
                                                            const opts = [
                                                                {value: 'lead', label: bitrix.card_type_lead[lang]},
                                                                {value: 'contact', label: bitrix.card_type_contact[lang]},
                                                                {value: 'deal', label: bitrix.card_type_deal[lang]},
                                                            ];
                                                            return parseCardTypes(callConfig.card_type)
                                                                .map((v) => opts.find((o) => o.value === v))
                                                                .filter(Boolean);
                                                        })()}
                                                        onChange={(ev) => setCallConfig(prev => ({
                                                            ...prev,
                                                            card_type: parseCardTypes((ev || []).map((o) => o.value)),
                                                        }))}
                                                        options={[
                                                            {value: 'lead', label: bitrix.card_type_lead[lang]},
                                                            {value: 'contact', label: bitrix.card_type_contact[lang]},
                                                            {value: 'deal', label: bitrix.card_type_deal[lang]},
                                                        ]}
                                                        isSearchable={false}
                                                    />
                                                </Box>
                                            </Box>
                                            {parseCardTypes(callConfig.card_type).map((cardType) => {
                                                const typeOptions = cardType === 'deal'
                                                    ? dealTypes
                                                    : cardType === 'lead'
                                                        ? leadTypes
                                                        : [];
                                                const typesLabel = cardType === 'deal'
                                                    ? bitrix.deal_types_label[lang]
                                                    : bitrix.lead_types_label[lang];
                                                const assignedEntity = callConfig.assigned?.[cardType]
                                                    || (cardType === 'deal'
                                                        ? { stage: [], order: 'ASC' }
                                                        : cardType === 'contact'
                                                            ? { order: 'ASC' }
                                                            : { status: [], order: 'ASC' });
                                                const selectedIds = cardType === 'deal'
                                                    ? (assignedEntity.stage || [])
                                                    : (assignedEntity.status || []);
                                                const orderValue = normalizeOrder(assignedEntity.order);
                                                return (
                                                    <Box key={cardType} sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
                                                        {cardType !== 'contact' && typeOptions.length > 0 && (
                                                            <Box>
                                                                <Typography variant="subtitle2" fontWeight={600} sx={{mb: 1, color: 'text.secondary'}}>
                                                                    {typesLabel}
                                                                </Typography>
                                                                <Box sx={{minWidth: 200}}>
                                                                    <Select
                                                                        isMulti
                                                                        styles={customStyles}
                                                                        menuPlacement="auto"
                                                                        menuPortalTarget={document.body}
                                                                        value={selectedIds.map(id => {
                                                                            const lt = typeOptions.find(l => l.id === id);
                                                                            return lt ? {value: lt.id, label: lt.name} : {value: id, label: id};
                                                                        })}
                                                                        onChange={(ev) => setCallConfig(prev => ({
                                                                            ...prev,
                                                                            assigned: {
                                                                                ...(prev.assigned || emptyAssigned()),
                                                                                [cardType]: {
                                                                                    ...(prev.assigned?.[cardType] || (cardType === 'deal'
                                                                                        ? { stage: [], order: 'ASC' }
                                                                                        : { status: [], order: 'ASC' })),
                                                                                    ...(cardType === 'deal'
                                                                                        ? { stage: (ev || []).map(o => o.value) }
                                                                                        : { status: (ev || []).map(o => o.value) }),
                                                                                },
                                                                            },
                                                                        }))}
                                                                        options={typeOptions.map(lt => ({value: lt.id, label: lt.name}))}
                                                                        isSearchable={false}
                                                                    />
                                                                </Box>
                                                            </Box>
                                                        )}
                                                        <Box>
                                                            <Typography variant="subtitle2" fontWeight={600} sx={{mb: 1, color: 'text.secondary'}}>
                                                                {bitrix.order_label[lang]} ({cardType === 'deal' ? bitrix.card_type_deal[lang] : cardType === 'contact' ? bitrix.card_type_contact[lang] : bitrix.card_type_lead[lang]})
                                                            </Typography>
                                                            <Box sx={{minWidth: 200}}>
                                                                <Select
                                                                    styles={customStyles}
                                                                    menuPlacement="auto"
                                                                    menuPortalTarget={document.body}
                                                                    value={{
                                                                        value: orderValue,
                                                                        label: orderValue === 'ASC' ? bitrix.order_asc[lang] : bitrix.order_desc[lang],
                                                                    }}
                                                                    onChange={(ev) => setCallConfig(prev => ({
                                                                        ...prev,
                                                                        assigned: {
                                                                            ...(prev.assigned || emptyAssigned()),
                                                                            [cardType]: {
                                                                                ...(prev.assigned?.[cardType] || (cardType === 'deal'
                                                                                    ? { stage: [], order: 'ASC' }
                                                                                    : cardType === 'contact'
                                                                                        ? { order: 'ASC' }
                                                                                        : { status: [], order: 'ASC' })),
                                                                                order: normalizeOrder(ev?.value),
                                                                            },
                                                                        },
                                                                    }))}
                                                                    options={[
                                                                        {value: 'ASC', label: bitrix.order_asc[lang]},
                                                                        {value: 'DESC', label: bitrix.order_desc[lang]},
                                                                    ]}
                                                                    isSearchable={false}
                                                                />
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                );
                                            })}
                                        </Box>
                                        )}
                                        
                                        <Box sx={{display: 'flex', gap: 1.5, pt: 1}}>
                                            <Button
                                                variant="contained"
                                                size="medium"
                                                disabled={saving}
                                                sx={{bgcolor: primary, '&:hover': {bgcolor: primary}, borderRadius: 2, textTransform: 'none', fontWeight: 600}}
                                                onClick={() => handleSaveSelected(selectedUsers)}
                                            >
                                                {isMulti ? bitrix.save_selected[lang] : global.edit[lang]}
                                            </Button>
                                        </Box>
                                    </Box>
                                </>
                            )}
                        </Paper>
                        )}
                    </div>
                )}

                <div className="tableParent" style={{marginTop: 24}}>
                    <Paper sx={{...cardPaperSx, p: 2.5}}>
                        <Typography variant="subtitle1" fontWeight={700} sx={{mb: 1.5, color: 'text.primary'}}>
                            {crm.config[lang]}
                        </Typography>
                        <Box component="ul" sx={{m: 0, pl: 2.5, color: 'text.secondary'}}>
                            <li><Typography variant="body2">{bitrix.card[lang]}</Typography></li>
                            <li><Typography variant="body2">{amo.record[lang]}</Typography></li>
                        </Box>
                    </Paper>
                </div>
            </Wrapper>
        </>
    );
}

export default Bitrix24;
